import { AddTradingOfferPageContextType } from '../types/AddTradingOfferPageContextType';

export const addTradingOfferPageInitValue: AddTradingOfferPageContextType = {
  data: {
    tradingOfferType: null,
    actionType: '',
    partnerOptions: [],
    selectedPartnerOption: null,
    holdingClassOptions: [],
    selectedHoldingClassOption: null,
    partnerCurrentSharesCount: 0,
    sharesToTransfer: 0,
    maxSharesToTransfer: 0,
    isPartialAmountEnabled: false,
    price: 0,
    isPricePerShare: true,
    pricePerShare: 0,
    totalOfferPrice: 0,
    startDate: '',
    endDate: '',
    societyId: '',
    societyName: '',
    isPartnerView: false,
    isAdmin: false,
    isReadOnly: false,
    isLoading: true,
    isMarketClosed: false,
  },
  actions: {
    handleChangePartner: () => {},
    handleSearchPartnerByTerm: async () => [],
    handleChangeHoldingClass: () => {},
    handleSearchHoldingClassByTerm: async () => [],
    handleChangeSharesToTransfer: () => {},
    handleChangeIsPartialAmountEnabled: () => {},
    handleChangePrice: () => {},
    handleChangeIsPricePerShare: () => {},
    handleChangeStartDate: () => {},
    handleChangeEndDate: () => {},
    handleReviewTradingOffer: () => {},
  },
};
